import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import { setSearchEngine } from './actions';
import type { SearchEngine } from 'SearchEngine-Types';

export const searchEngineType = createReducer({} as SearchEngine).handleAction(
  [setSearchEngine],
  (_state, action) => action.payload,
);
const searchEngineReducer = combineReducers({
  searchEngineType,
});

export default searchEngineReducer;
export type SearchEngineState = ReturnType<typeof searchEngineReducer>;
